import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/activePackagesSaga";
import MonthPicker from "../../../../components/reactMonthPicker/reactMonthPicker";

const DatePicker = () => {
  const dispatch = useDispatch();

  const { startDate, endDate } = useSelector(
    (state) => state.activePackages.selectedFilters.requestDates
  );
  const { calendarEndDate, calendarStartDate } = useSelector(
    (state) => state.activePackages.currentUser
  );

  return (
    <div className="date-select-box select-box ">
      <p className="offers-title">Date</p>
      <MonthPicker
        startDate={startDate}
        endDate={endDate}
        calendarStartDate={calendarStartDate}
        calendarEndDate={calendarEndDate}
        updateDates={(startDate, endDate) =>
          dispatch(actionCreators.updateDates({ startDate, endDate }))
        }
      />
    </div>
  );
};

export default DatePicker;
